import { FC, useReducer, ReactNode } from 'react';
import { ProgressSidebar } from '../ProgressSidebar/ProgressSidebar';

import Modal from '../Modal';

import { buildState } from './GetStarted.state';
import { getStartedReducer } from './GetStarted.reducer';
import { GetStartedProvider } from './GetStarted.context';
import { hideModal } from './GetStarted.actions';

import { Step } from '../../../types/tour';

import styles from './GetStarted.module.css';

export type Props = {
  steps: Step[];
  current: number;
  children: ReactNode | undefined;
  title: string;
  leaveTourLink: string;
};

export const GetStarted: FC<Props> = ({
  steps,
  children,
  current = 0,
  title,
  leaveTourLink,
}) => {
  const [state, dispatch] = useReducer(
    getStartedReducer,
    buildState(steps, current),
  );

  return (
    <GetStartedProvider state={state} dispatch={dispatch}>
      {state.modal && (
        <Modal
          title={state.modal.title}
          onClose={() => {
            dispatch(hideModal());
          }}
        >
          {state.modal.content}
        </Modal>
      )}
      <div className={styles.getStartedWrapper}>
        <div className={styles.getStartedSidebar}>
          <ProgressSidebar
            steps={state.steps}
            current={state.steps[state.current].id}
            title={title}
            leaveTourLink={leaveTourLink}
          />
        </div>
        <div className={styles.getStartedContent}>{children}</div>
      </div>
    </GetStartedProvider>
  );
};
